import _ from "lodash";
import React from "react";
import Reflux from "reflux";

import logger from "../../utils/LoggerFrontend";
import { Heading } from "../../Components/Heading";
import Actions from "../../Actions";
import CampaignCreationStore from "../../Stores/CampaignCreationStore";
import { Store__System, CustomerSucessController } from "@talentbait/shared-components";
import { withTranslation } from "react-i18next";
import { formatIntlNumber } from "../../utils/Helpers";
import classNames from "classnames";

const MIN_BUDGET_SIZE = 150; // EURO

class CampaignCreatePackages extends Reflux.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: null,
      searchTerm: ""
    };

    this.stores = [Store__System, CampaignCreationStore];

    logger.debug("CampaignCreatePackages:constructor", "called...", { state: this.state });
  }
  componentDidMount() {
    const { userProfile } = this.state;
    if (!userProfile) {
      return;
    }
    const orgaId = userProfile.organizationId;
    logger.debug("CampaignCreatePackages:componentDidMount", "called... orgaId:", orgaId);

    Actions.loadPackagesByOrga(orgaId);
  }
  handlePackageSelection(campaignBudget, packageId, minClicks, selectedChannels, duration) {
    const { t } = this.props;

    logger.debug("CampaignCreatePackages:handlePackageSelection", "called...", {
      campaignBudget,
      packageId,
      minClicks,
      selectedChannels
    });
    //
    // Make sure that the passed in campaignBudget is a number and not a string!
    //

    if (!packageId) {
      this.setState({
        errorMsg: t("No package name passed")
      });
      return Actions.campaignCreateUpdatePackageData({
        packageId: undefined,
        lifeTimeBudget: undefined,
        minClicksPackage: undefined
      });
    }

    let data = {};
    if (!isNaN(campaignBudget) && campaignBudget !== "") {
      logger.debug(
        "CampaignCreatePackages:handlePackageSelection",
        "Found a campaignBudget...",
        campaignBudget
      );
      var val = parseInt(campaignBudget, 10);

      const errorMsg = t("Please select a valid price (at least {{minBudget}} EUR).", {
        minBudget: MIN_BUDGET_SIZE
      });
      // If the chosen budget is smaller than the minium show an error
      if (val && val < MIN_BUDGET_SIZE) {
        this.setState({ errorMsg });
        return Actions.campaignCreateUpdatePackageData({
          packageId: undefined,
          lifeTimeBudget: undefined,
          minClicksPackage: undefined
        });
      }
      // -----------------------------------------------------------------
      // This is the case were everything went right!
      // -----------------------------------------------------------------
      CustomerSucessController.send("CampaignCreatePackages:packageSelection", {
        campaignBudget: campaignBudget,
        packageId
      });

      data = {
        lifeTimeBudget: campaignBudget,
        packageId,
        minClicksPackage: minClicks,
        campaignDuration: duration
      };

      if (selectedChannels) {
        data.selectedChannels = selectedChannels;
      }

      this.setState({
        errorMsg: undefined
      });
    }
    // Make sure the passed in campaignBudget is not empty!
    else if (!campaignBudget || campaignBudget === null || campaignBudget === undefined) {
      this.setState({
        errorMsg: "1"
      });
      data = {
        packageId: undefined,
        minClicksPackage: undefined,
        lifeTimeBudget: undefined
      };
    } else if (isNaN(campaignBudget) || campaignBudget === undefined || campaignBudget === null) {
      logger.debug(
        "CampaignCreatePackages:handlePackageSelection",
        "Found a campaignBudget...",
        campaignBudget
      );
      this.setState({
        errorMsg: "2"
      });
      data = {
        packageId: undefined,
        minClicksPackage: undefined,
        lifeTimeBudget: undefined
      };
    } else {
      this.setState({
        errorMsg: t("Oops, an error occurred. Please contact the support team")
      });
      data = {
        packageId: undefined,
        minClicksPackage: undefined,
        lifeTimeBudget: undefined
      };
    }

    //TODO: TEMPORARY SOLUTION FOR AD ASSISTANT
    if (this.props.setCampaignBudgetData) {
      this.props.setCampaignBudgetData(data);
    }

    return Actions.campaignCreateUpdatePackageData(data);
  }

  renderPackageImage(nameShort, color) {
    return (
      <div className="campaign-creation__package-image">
        <span className="campaign-creation__letter" style={{ backgroundColor: color || "#a5a5a5" }}>
          {nameShort}
        </span>
      </div>
    );
  }
  renderPackageHeader(name, description) {
    return (
      <div className="campaign-creation__center-col">
        <h4 className="campaign-creation__package-name">{name}</h4>
        <p className="campaign-creation__package-desc">{description}</p>
        {this.renderAdditionalLocCost()}
      </div>
    );
  }

  onChangeRadioValue = (packageId, budget, minClicks, duration) => {
    const { packages } = this.state;
    const selectedChannels = (packages?.find(({ id }) => id === packageId) || {}).selectedChannels;

    this.handlePackageSelection(budget, packageId, minClicks, selectedChannels, duration);
  };

  renderRadioButton(packageId, budget, minClicks, duration) {
    const { packageId: packageType } = this.state;

    return (
      <label htmlFor="package-radio-id" className="container_check">
        <input
          id="package-radio-id"
          type="radio"
          value={packageId}
          checked={packageType === packageId}
          name="radio"
          onChange={() => this.onChangeRadioValue(packageId, budget, minClicks, duration)}
        />
        <span className="checkmark_custom" />
      </label>
    );
  }

  renderBudget(packageId, budget) {
    const { packageId: packageType, extraBudgetLocations, userProfile } = this.state;

    let extraBudget = 0;
    extraBudgetLocations.forEach((elem) => {
      extraBudget += elem.price;
    });

    const classStr = classNames({
      "campaign-creation__pricing-nr": true,
      "campaign-creation__pricing-nr--active": packageId === packageType
    });

    return (
      <span className={classStr}>
        €{formatIntlNumber(budget + extraBudget, { language: userProfile?.language })}
      </span>
    );
  }

  generatePackageDescription(duration, minClicks, channels) {
    const { t } = this.props;
    const minClicksTotal = minClicks * 6;

    //Google Display, LinkedIn, Twitter
    return t(
      "{{duration}} days duration / {{minClicks}} - {{minClicksTotal}} minimum clicks / Channels: {{channels}}",
      {
        duration,
        minClicks,
        minClicksTotal,
        channels: channels.join(", ")
      }
    );
  }

  renderAdditionalLocCost() {
    const { t } = this.props;

    const { extraBudgetLocations } = this.state;
    const length = extraBudgetLocations.length;
    const standort = length === 1 ? t("Location") : t("Locations");

    let locationsCost = 0;
    for (let i = 0; i < length; i++) {
      locationsCost += extraBudgetLocations[i].price;
    }
    if (length > 0) {
      return (
        <div style={{ color: "green" }}>
          + {length} {t("Extra")} {standort} {locationsCost}€
        </div>
      );
    }
  }

  renderNormalPackage(
    packageId,
    nameShort,
    name,
    budget,
    description,
    color,
    currentPackageId,
    minClicks,
    channels,
    duration = 30
  ) {
    logger.debug("CampaignCreatePackages:renderNormalPackage", "called...", {
      packageId,
      nameShort,
      name,
      budget,
      description,
      color,
      currentPackageId,
      minClicks,
      duration
    });

    const classStr = classNames({
      "campaign-creation__package": true,
      "campaign-creation__package--active": packageId === currentPackageId
    });

    var newDesc =
      description ||
      this.generatePackageDescription(
        duration,
        minClicks,
        channels.map((item) => item.channel_full_name)
      );

    return (
      <div
        className={classStr}
        key={packageId}
        onClick={() => this.onChangeRadioValue(packageId, budget, minClicks, duration)}
      >
        <div className="campaign-creation__package-item">
          {this.renderPackageImage(nameShort, color)}
          {this.renderPackageHeader(name, newDesc)}
          <div className="campaign-creation__pricing right">
            {this.renderRadioButton(packageId, budget, minClicks, duration)}
            {this.renderBudget(packageId, budget)}
          </div>
        </div>
      </div>
    );
  }

  renderPackages() {
    let { packages = [], packageId: packageType, searchTerm } = this.state;

    packages = _.sortBy(packages, ["name"]);

    if (searchTerm !== "") {
      packages = _.filter(packages, (el) => {
        const st = (searchTerm || "").toLowerCase();
        if ((el.name || "").toLowerCase().indexOf(st) > -1) {
          return true;
        }
        return false;
      });
    }

    logger.debug("CampaignCreatePackages:renderPackages", "called...", {
      packages,
      packageType
    });

    return packages.map((item) => {
      return this.renderNormalPackage(
        item.id,
        item.nameShort,
        item.name,
        item.budget,
        item.description,
        item.color,
        packageType,
        item.minClicks,
        item.selectedChannels,
        item.duration
      );
    });
  }

  search = (e) => {
    const searchTerm = e.target.value;
    this.setState({ searchTerm });
  };

  clearSearch = () => {
    this.setState({ searchTerm: "" });
  };

  render() {
    const { t } = this.props;
    const { errorMsg, searchTerm } = this.state;

    const classSearch = classNames({
      "dashboard__search-close": true,
      "dashboard__search-close--close": searchTerm == ""
    });

    return (
      <div>
        <div className="App campaign-create__pricing-step center fade-in">
          <Heading
            title={t("Select package")}
            subtitle={t(
              "Please select the package that will provide your job advertisement with the required number of visitors"
            )}
          />
          <div className="dashboard__search dashboard__search--packages">
            <input
              type="text"
              onChange={this.search}
              placeholder={t("Search package")}
              value={searchTerm}
              className="dashboard__search-field"
            />
            <div className={classSearch} onClick={this.clearSearch}>
              x
            </div>
            <p className="error" style={{ marginTop: "6px" }}>
              {errorMsg}
            </p>
            <br />

            <br />
          </div>
          <div className="left">{this.renderPackages()}</div>
          <br />
          <br />
        </div>
        {this?.props?.children}
      </div>
    );
  }
}

export default withTranslation()(CampaignCreatePackages);
